import React from 'react';
import { colors }  from '../config';

const Spinner = ({ size = 16, color = colors.orange, ...rest }) => (
  <div {...rest}>
    <style jsx>{`
      div {
        display: inline-block;
        border-radius: 50%;
        border: 0.25em solid rgba(0, 0, 0, 0.15);
        width: 2em;
        height: 2em;
        animation: spin 1s linear infinite;
      }

      div {
        border-left-color: ${color};
        font-size: ${size}px;
      }

      @keyframes spin {
        100% {
          transform: rotate(360deg);
        }
      }
    `}</style>
  </div>
);

export default Spinner;
